module.exports = __webpack_public_path__ + "img/linkedin.873b1343.png";